/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationsSubscription200Response
 */
export interface GetReservationsSubscription200Response {
    /**
     * 
     * @type {string}
     * @memberof GetReservationsSubscription200Response
     */
    plan: GetReservationsSubscription200ResponsePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof GetReservationsSubscription200Response
     */
    paymentFrequency: GetReservationsSubscription200ResponsePaymentFrequencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof GetReservationsSubscription200Response
     */
    nextBillingDate: Date;
}


/**
 * @export
 */
export const GetReservationsSubscription200ResponsePlanEnum = {
    Basic: 'basic',
    Core: 'core',
    Premium: 'premium'
} as const;
export type GetReservationsSubscription200ResponsePlanEnum = typeof GetReservationsSubscription200ResponsePlanEnum[keyof typeof GetReservationsSubscription200ResponsePlanEnum];

/**
 * @export
 */
export const GetReservationsSubscription200ResponsePaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type GetReservationsSubscription200ResponsePaymentFrequencyEnum = typeof GetReservationsSubscription200ResponsePaymentFrequencyEnum[keyof typeof GetReservationsSubscription200ResponsePaymentFrequencyEnum];


/**
 * Check if a given object implements the GetReservationsSubscription200Response interface.
 */
export function instanceOfGetReservationsSubscription200Response(value: object): value is GetReservationsSubscription200Response {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    if (!('nextBillingDate' in value) || value['nextBillingDate'] === undefined) return false;
    return true;
}

export function GetReservationsSubscription200ResponseFromJSON(json: any): GetReservationsSubscription200Response {
    return GetReservationsSubscription200ResponseFromJSONTyped(json, false);
}

export function GetReservationsSubscription200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationsSubscription200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'paymentFrequency': json['paymentFrequency'],
        'nextBillingDate': (new Date(json['nextBillingDate'])),
    };
}

export function GetReservationsSubscription200ResponseToJSON(json: any): GetReservationsSubscription200Response {
    return GetReservationsSubscription200ResponseToJSONTyped(json, false);
}

export function GetReservationsSubscription200ResponseToJSONTyped(value?: GetReservationsSubscription200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'paymentFrequency': value['paymentFrequency'],
        'nextBillingDate': ((value['nextBillingDate']).toISOString()),
    };
}

